import { Company } from '@modules/search/types'
import { Tag } from '@modules/shortlist/types'

export enum ImportProspectsView {
  'event' = 'event',
  'prospect' = 'prospect',
  'shortlist' = 'shortlist',
}

export enum ImportProspectsRequestTypes {
  'incoming' = 'Incoming',
  'outgoing' = 'Outgoing',
}

export enum ImportProspectsStatus {
  'requested' = 'Requested',
  'agreed' = 'Agreed',
  'declined' = 'Declined',
  'canceled' = 'Canceled',
}

export type ImportProspect = Pick<Company, 'id' | 'name'> & { tags?: Tag[]; status: ImportProspectsStatus }

export enum ImportProspectsQsFilterKey {
  event = 'imp-eventId',
  requests = 'imp-requests',
  status = 'imp-status',
  tags = 'imp-tags',
}
